import { DASHBOARD_EVENTS } from './dashboardEvents';
import { ROUTES_EVENTS } from './routesEvents';
import { STATS_EVENTS } from './statsEvents';
import { SETTINGS_EVENTS } from './settingsEvents';
import { mixpanel, traffic2 } from '../../utils/buildAnalyticsEvents';
import { SIDEBAR_EVENTS } from './sidebarEvents';
import { SUGGESTED_ITEMS_EVENTS } from './suggestedItemsEvents';
import { PLAN_EVENTS } from './planEvents';
import { ERROR_EVENTS } from './errorEvents';

export const EVENT_MAP = {
  SAMPLE_CLICK: {
    ...mixpanel('Sample Click'),
    ...traffic2('only.five.level.deep.click')
  },
  SAMPLE_IMPRESSION: {
    ...mixpanel('Sample Impression'),
    ...traffic2('sample.impression')
  },
  NAVIGATION_CLICK: {
    ...mixpanel('Navigation Click'),
    ...traffic2('navigation_click')
  },
  ...ROUTES_EVENTS,
  ...DASHBOARD_EVENTS,
  ...STATS_EVENTS,
  ...SETTINGS_EVENTS,
  ...SIDEBAR_EVENTS,
  ...SUGGESTED_ITEMS_EVENTS,
  ...PLAN_EVENTS,
  ...ERROR_EVENTS
};

export const EVENT_KEYS = [...Object.keys(EVENT_MAP)].reduce((o, k) => ({ ...o, [k]: k }), {}) as {
  [P in keyof typeof EVENT_MAP]: P;
};

export type EventType = keyof typeof EVENT_KEYS;
